module.exports = __webpack_public_path__ + "static/media/logo.2a1584ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Navbar/logo.png
// module id = 285
// module chunks = 64